import { BackEndCodeLanguage } from '@prophecy/graphql-types/enums';
import { FROZEN_EMPTY_OBJECT } from '@prophecy/utils/constants';
import { useContext } from 'react';

import { ProjectContext, ProjectContextTypeReturnType } from './context';

export function useProjectState() {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    return FROZEN_EMPTY_OBJECT as ProjectContextTypeReturnType;
  }
  return context;
}

export const useIsPySparkSimplified = () => {
  const { language, backendLanguage } = useProjectState();
  return language === BackEndCodeLanguage.sql && backendLanguage === BackEndCodeLanguage.python;
};
